import { Close } from '@mui/icons-material';
import { Stack, Tab, Tabs, Typography } from '@mui/material';
import { MentorshipStatusEnum, Tag } from '@juno/client-api/model';
import { MentorshipFilter } from './types';

interface FiltersAppliedProps {
  tagFilters: Tag[];
  mentorshipFilters?: MentorshipFilter[];
  disableAll?: boolean;
  removeTagFilter: (tag: Tag) => void;
  removeMentorshipFilter?: (status: MentorshipStatusEnum) => void;
}

const FilterItemApplied = ({
  label,
  onClick,
  disabled,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <Tab
      label={
        <>
          {label} <Close sx={{ fontSize: 16, ml: 1 }} />
        </>
      }
      sx={{
        mr: 1,
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        border: (theme) => `1px solid ${theme.palette.primary.main}`,
        color: (theme) => theme.palette.primary.main,
        textTransform: 'none',
        borderRadius: 2,
        flexDirection: 'row',
        padding: '2px 6px',
        minHeight: 32,
        fontSize: 12,
      }}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export const FiltersApplied = ({
  tagFilters,
  mentorshipFilters,
  disableAll,
  removeTagFilter,
  removeMentorshipFilter,
}: FiltersAppliedProps) => {
  return (
    <Stack direction='row' alignItems='center'>
      <Typography variant='subtitle1' sx={{ mr: 2, minWidth: 100 }}>
        Filters ({tagFilters.length + (mentorshipFilters?.length || 0)})
      </Typography>
      <Tabs
        value={false}
        onChange={() => {}}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='scrollable auto tabs example'
        sx={{ alignItems: 'center' }}
      >
        {tagFilters.map((f) => (
          <FilterItemApplied
            label={f.value}
            onClick={() => removeTagFilter(f)}
            disabled={disableAll}
            key={f.id}
          />
        ))}
        {mentorshipFilters?.map((f) => (
          <FilterItemApplied
            label={f.label}
            onClick={() => removeMentorshipFilter?.(f.value)}
            disabled={disableAll}
            key={f.value}
          />
        ))}
      </Tabs>
    </Stack>
  );
};
